import { FormHelperText, TextField } from "@material-ui/core"
import { trackPopUpClicks } from "common/analytics"
import { getDay, getHours, setHours, setMinutes, startOfDay } from "date-fns"
import he from "date-fns/locale/he"
import { useField } from "formik"
// import { TextField } from "formik-material-ui"
import { useEffect, useRef, useState } from "react"
import DatePicker, { registerLocale, setDefaultLocale } from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css"
import styled from "styled-components"
// https://reactdatepicker.com/

const StyledWrapper = styled.div`
  height: 81.6px;
  display: flex;
  width: 100%;
  width: 100%;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-end;
`
const StyledError = styled(FormHelperText)`
  bottom: -0.5em;
  right: 0px;
  font-size: 12px !important;
  height: 15.594px;
  margin-top: 3px;
`

const StyledPickerWrapper = styled.div<{ $default: boolean }>`
  height: fit-content;
  width: 100%;
  .react-datepicker-popper {
    z-index: 10;
  }
  * {
    font-family: MazdaType, OENaPro, sans-serif;
  }
  .react-datepicker__time-list-item--selected {
    background-color: ${(p) => p.theme.colors.mazdaRed} !important;
  }
  .react-datepicker__day--selected {
    background-color: ${(p) => p.theme.colors.mazdaRed} !important;
  }
  .react-datepicker__header {
    background-color: ${(p) => p.theme.colors.lightGrey} !important;
  }
`

type CalendarInputProps = {
  name: string
  label: string
  minTime?: number
  maxTime?: number
  disable?: boolean
  isWorkingFriday?: boolean
}

const DateTimeInput = ({
  name,
  label,
  minTime,
  maxTime,
  disable,
  isWorkingFriday,
}: CalendarInputProps) => {
  // formik
  const [field, meta, helpers] = useField(name)
  const { value, error, touched } = meta
  const { setValue } = helpers

  // states:
  const [date, setDate] = useState(value)
  const ref = useRef(null)

  // Filter dates
  const isWeekday = (date) => {
    const day = getDay(date)
    if (isWorkingFriday) {
      return day !== 6
    }
    return day !== 5 && day !== 6
  }
  // Filter times
  const filterPassedTime = (time) => {
    const currentDate = new Date()
    const selectedDate = new Date(time)
    return currentDate.getTime() < selectedDate.getTime()
  }

  const getDateTwoDaysFromNow = (): Date => {
    const now = new Date()
    const twoDaysFromNow = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate() + 2
    )
    return twoDaysFromNow
  }

  const minDate = getDateTwoDaysFromNow()

  const resetSelectedDate = () => {
    setDate(null)
    setValue(null)
  }

  useEffect(() => {
    if (date) {
      if (startOfDay(date).getTime() < startOfDay(minDate).getTime()) {
        console.log("date is before minDate")
        resetSelectedDate()
      } else {
        setValue(date)
      }
    }
  }, [date])

  // Reset date when time constraints change
  useEffect(() => {
    if (date) {
      // Check if the current selected time is outside the new constraints
      const selectedDate = new Date(date)
      const selectedHours = selectedDate.getHours()

      const isTimeInvalid =
        (minTime && selectedHours < minTime) ||
        (maxTime && selectedHours > maxTime)

      if (isTimeInvalid) {
        setDate(null)
        setValue(null)
      }
    }
  }, [minTime, maxTime])

  setDefaultLocale("he_IL")
  registerLocale("he_IL", he)
  return (
    <StyledWrapper>
      <StyledPickerWrapper $default={date}>
        <DatePicker
          customInput={<TextField label={label} {...field} />}
          required
          ref={ref}
          locale="he_IL"
          className="form-control"
          selected={date ? date : ""}
          onChange={(date) => {
            setDate(date)
          }}
          value={date}
          name={name}
          onCalendarOpen={() => {
            trackPopUpClicks("קביעת ביקור", "treatmentDate")
          }}
          // date:
          dateFormat="dd/MM/yy, HH:mm"
          // maxDate={twoWeeksFromNow}
          minDate={minDate}
          filterDate={isWeekday}
          //time:
          showTimeSelect
          timeIntervals={30}
          timeFormat="HH:mm"
          timeCaption="שעה"
          minTime={minTime && setHours(setMinutes(new Date(), 0), minTime)}
          maxTime={maxTime && setHours(setMinutes(new Date(), 0), maxTime)}
          filterTime={filterPassedTime}
          autoComplete="off"
          disabled={disable}
          onCalendarClose={() => {
            if (getHours(date) < minTime) {
              resetSelectedDate()
            }
          }}

          // maxTime={isToday && maxTimeState}
          // onCalendarOpen={handleCalendarOpen}
          // onCalendarClose={handleCalendarClose}
          //   open={isOpen}
          //   onSelect={checkCurrentDay}
        />
      </StyledPickerWrapper>
      {error && touched ? (
        <StyledError id={`${name}-helper-text`} error>
          {error}
        </StyledError>
      ) : (
        <StyledError id={`${name}-helper-text`}>{"  "}</StyledError>
      )}
    </StyledWrapper>
  )
}
export default DateTimeInput
